/**
 * Created by Anam Farrukh on 10/19/2015
 */

var app = angular.module('tmx-common',['ngMaterial','ui.router','ngMessages','ngMdIcons','ngAnimate','tmx-configurations','satellizer']);

app.config(config);

function config( $httpProvider,ENV,$authProvider) {
    var HEADER_NAME = 'TMX-Generic-Response-Handler';
    var count=0;
    //var ReqURL= "";
    //var ResURL ="";
    //function invoke(sharedPropertiesProvider){
    //    sharedPropertiesProvider
    //        .$get();
    //
    //}

    $authProvider.facebook({
        clientId: ENV.facebookAppId,
        url: ENV.AuthServer + '/api/Account/SattelizerFacebook'
    });

    $authProvider.google({
        clientId: ENV.googleAppId,
        url: ENV.AuthServer +'/api/Account/SattelizerGoogle'
    });

    $authProvider.twitter({
        url: '/auth/twitter'
    });

    $authProvider.loginUrl = ENV.AuthServer +'/token';

    function skipIfLoggedIn($q, $auth) {
        var deferred = $q.defer();
        if ($auth.isAuthenticated()) {
            deferred.reject();
        }
        else {
            deferred.resolve();
        }
        return deferred.promise;
    }

    function loginRequired($q, $location, $auth) {
        var deferred = $q.defer();
        if ($auth.isAuthenticated()) {
            deferred.resolve();
        }
        else {
            $location.path('/login');
        }
        return deferred.promise;
    }

    function isAuthenticated($auth) {
        return $auth.isAuthenticated();
    }
/////////////////////////////////////////HTTP RESPONSE OF REGISTER USER INTERCEPTOR/////////////////////////////////
    //Register the interceptor via an anonymous factory

    /*  Created By Anam Farrukh  */
    $httpProvider.interceptors.push(['$q','ServerExceptionService', '$injector', 'ProgressBar', 'APP_CONSTANTS',function($q,ServerExceptionService,$injector,ProgressBar,APP_CONSTANTS) {

        return {
            'request': function(config) {
                ProgressBar.show(config.url);

                //Before sending any request clear out all sever errors

                //if(!(config !=null && config.headers !=null && config.headers["Content-Type"] !=null))
                //return;

                var AuthService = $injector.get('$auth');
                var HttpService = $injector.get('$http');
            //  if(!AuthService.isAuthenticated())

                //var AuthService = $injector.get('$auth');
                if(config.url.indexOf("http")!= -1 && config.url.indexOf("token")== -1   && !AuthService.isAuthenticated() && localStorage.getItem("refresh_token") !=null) {
                    var obj = {
                        grant_type: "refresh_token",
                        client_id : APP_CONSTANTS.cliendId,
                        refresh_token: localStorage.getItem("refresh_token")
                           
                    };

                       //HttpService.post(ENV.AuthServer+"/token", obj, { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept':'*/*'}})
                       //      .then(function(response) {
                       //
                       //      });

                    AuthService.login(obj).then(function() {
                    })
                        .catch(function(response) {
                            AuthService.logout();
                        });

                }
                if (config.url.localeCompare($authProvider.loginUrl) != 0) {

                       //addHeaderToConfig(config);

                }
                else {

                }

                return config;

            },

            'response': function(response) {
                ProgressBar.hide(response.config.url);
                var ResponseObj = {};
                var ToastService = $injector.get('ToastService');

               // ResURL = $location.url();
                if (angular.isObject(response.data) && (response.status==200)) {
                    ResponseObj = checkResponseCode(response);
                    if (ResponseObj.code >= 400 && ResponseObj.code <= 500) { //Http response code: 200 but custom code gives error
                        if(ResponseObj.code!=412){
                            ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction(ResponseObj.message);
                            ToastService.showCustomToast("error", ServerExceptionService.Displaymsg);
                            return $q.reject(response); //reject the response
                        }

                    }


                }


                return response;
            },

            'requestError': function(rejection){
                ProgressBar.hide(rejection.config.url);
            },

            'responseError': function(rejection) {
                ProgressBar.hide(rejection.config.url);
                var ToastService = $injector.get('ToastService');

                var shouldHandle = (angular.isDefined(rejection) &&
                                    angular.isDefined(rejection.config) &&
                                    angular.isDefined(rejection.config.headers) &&
                                    angular.isDefined(rejection.config.headers[HEADER_NAME]) &&
                                    angular.isObject(rejection.data)
                );
                 
                if (shouldHandle) {
                    // --- Your generic error handling goes here ---
                    if(ServerExceptionService.Displaymsg != rejection.data.message){
                        ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction(rejection.data.message);
                    }
                    else{
                        return $q.reject(rejection);
                    }


                }
                else if (rejection.status >= 400 && rejection.status <= 600){
                    if(rejection.status==400 && rejection.statusText=="Bad Request") {
                        if(ServerExceptionService.Displaymsg != rejection.data.Message){
                             
                            ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction(rejection.data.Message);
                        }
                        else{
                            return $q.reject(rejection);
                        }


                    }
                    //ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction(rejection.data.error_description);
                    else if(angular.isDefined(rejection.data.error_description)){
                        if(ServerExceptionService.Displaymsg != rejection.data.error_description){
                            ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction(rejection.data.error_description);
                        }
                        else{
                            return $q.reject(rejection);
                        }

                    }
                    else if(angular.isDefined(rejection.data.Message) && !angular.isDefined(rejection.data.byteLength)){
                        if(ServerExceptionService.Displaymsg != rejection.data.Message){
                            ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction(rejection.data.Message);
                        }
                        else{
                            return $q.reject(rejection);
                        }


                    }
                    else if(!angular.isDefined(rejection.data.byteLength)){
                        var error = "No message returned from server on Bad Request";
                        if(ServerExceptionService.Displaymsg != error){
                            ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction(error);
                        }
                        else{
                            return $q.reject(rejection);
                        }


                    }
                    //format Display Message
                    if(ServerExceptionService.Displaymsg.indexOf(" - ") > -1){//hyphen was found in the message => custom message returned from server
                        var ErrorString = ServerExceptionService.Displaymsg.split(" - ");
                        if(ServerExceptionService.Displaymsg != ErrorString[1]){
                            ServerExceptionService.Displaymsg = ErrorString[1];
                        }
                        else{
                            return $q.reject(rejection);
                        }

                    }
                }
                else{
                    if(rejection.status != -1){
                        var error = "Server Side Error!";
                        if(ServerExceptionService.Displaymsg != error){
                            ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction(error);
                        }
                        else{
                            return $q.reject(rejection);
                        }


                    }

                }
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

                 
                if(ServerExceptionService.Displaymsg != ""){
                    ToastService.showCustomToast("error", ServerExceptionService.Displaymsg);

                }
                return $q.reject(rejection);
            }

        };
        //////////////////////////////////////////////
        // --- Decorate $http to add a special header by default ---

        function addHeaderToConfig(config) {
            config = config || {};
            config.headers = config.headers || {};

            // Add the header

            config.headers[HEADER_NAME] = true;


            return config;
        }
////////////////////////////////////////////////////////////////////////////////////////////
        function checkResponseCode(response){
            var code = 0;
            var message = "";
            if(typeof response != 'undefined' && response != {} && response.data !=null && response.data.status !=null) {
                code = response.data.status.code;
                message = response.data.status.message;

                return {
                    'code': code,
                    'message': message
                }
            }
            else{
                return { emptyObj: "Response is Empty!"}
            }
        }
//////////////////////////////////////////////////////////////////////////////////////////////


    }]);

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

}

